// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".captcha[data-v-f29a9b1c]{display:flex;align-items:center}.captcha .left[data-v-f29a9b1c]{flex:1;margin-right:10px}.captcha .right[data-v-f29a9b1c]{display:flex;align-items:center;cursor:pointer}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
